import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { EopPlanSlug, buildPlanPageUrl, getBuildingIdFromUrl, getEopPages, getPlanSlugFromUrl, IEopPageConfig } from '../../eop-config/eop-page-config';

@Component({
  selector: 'prv-next-buttons',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterLink
  ],
  templateUrl: './prv-next-buttons.component.html',
  styleUrl: './prv-next-buttons.component.css' // optional, or remove this line
})
export class PrvNextButtonsComponent implements OnInit {
  totalPages: IEopPageConfig[] = [];
  icons = Icons;
  currentPlan: EopPlanSlug = 'al';
  currentBuildingId: string | null = null;
  currentRoute: string = '';
  currentIndex: number = -1;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateCurrentIndex();
    // Recompute on route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateCurrentIndex());
  }

  private updateCurrentIndex(): void {
    const url = this.router.url.replace(/\/+$/, '');
    this.currentPlan = getPlanSlugFromUrl(url);
    this.currentBuildingId = getBuildingIdFromUrl(url);
    this.totalPages = getEopPages(this.currentPlan);
    const segments = url.split('/');
    const lastSegment = segments[segments.length - 1]?.toLowerCase();
  
    this.currentRoute = lastSegment;
  
    if (this.totalPages?.length) {
      this.currentIndex = this.totalPages.findIndex(
        p => p.route.toLowerCase() === lastSegment
      );
    }
  }  

  hasPrevious(): boolean {
    return this.currentIndex > 0;
  }

  hasNext(): boolean {
    return this.currentIndex >= 0 && this.currentIndex < this.totalPages.length - 1;
  }

  goToPrevious(): void {
    if (this.hasPrevious() && this.currentBuildingId) {
      this.router.navigateByUrl(buildPlanPageUrl(this.currentPlan, this.currentBuildingId, this.totalPages[this.currentIndex - 1].route));
    }
  }

  goToNext(): void {
    if (this.hasNext() && this.currentBuildingId) {
      this.router.navigateByUrl(buildPlanPageUrl(this.currentPlan, this.currentBuildingId, this.totalPages[this.currentIndex + 1].route));
    }
  }
}
